import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarCard } from "@perxis-auto/ui-kit/lib/components/CarCard";
import { withEnabledComponent } from "../../../shared/lib/constructor/withEnabledComponent.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import { selectTags } from "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
const CardMarkers = withEnabledComponent(
  memo(function CardMarkers2({
    items,
    isLoading = false,
    limit = 3,
    mode = "singleLineDynamic",
    ...props
  }) {
    if (isLoading) {
      return /* @__PURE__ */ jsx(CarCard.MarkersSkeleton, {});
    }
    if (!items.length) {
      return null;
    }
    return /* @__PURE__ */ jsx(CarCard.Markers, { items, limit, mode, ...props });
  }),
  selectTags
);
export {
  CardMarkers
};
